import _ from 'lodash'
import Backbone from 'backbone'
import formHelper from 'scoreboard/components/form-helper'
import i18n from 'scoreboard/components/i18n'
import selects from 'scoreboard/components/selects'
import TagsChooser from 'scoreboard/components/tags-chooser'
import unwrapModel from 'scoreboard/components/unwrap-model'
import KeySet from './key-set'
import panelHeaderTemplate from './rollup-tree-panel-header.hbs'
import panelContentTemplate from './rollup-tree-key-set-panel.hbs'
import RollupTreeCollapsiblePanel from './rollup-tree-collapsible-panel'

/**
 * A DatasetsTreeCollapsiblePanel with a key set
 * @extends RollupTreeCollapsiblePanel
 */
const RollupTreeKeySetPanel = RollupTreeCollapsiblePanel.extend(/** @lends RollupTreeKeySetPanel.prototype */{

	tagName: 'form',

	labelKey: 'datasets.trees.keyset.name',

	events: _.extend({}, RollupTreeCollapsiblePanel.prototype.events, {
		'change select[name=keys]': 'onChangeKeys'
	}),

	/**
	 *
	 * @property {KeySet} model
	 * @param {Boolean} [options.collapsed=true] if the panel is collapsed
	 * @param {Array} configMenuOptions options to be passed into the
	 *     bootslide-clickable-menu for the panel.
	 */
	initialize: function(options) {
		this.options = options || {}
		const {id, label, keys = []} = unwrapModel(this.model)
		this.label = label
		this.keys = keys

		this.options.header = panelHeaderTemplate(_.extend({
			id,
			label: label || i18n.get('common.name'),
			size: id && _.size(this.keys),
			toggle: true
		}, this.options))

		this.options.content = panelContentTemplate({id})

		RollupTreeCollapsiblePanel.prototype.initialize.apply(this, arguments)
	},

	render: function() {
		RollupTreeCollapsiblePanel.prototype.render.apply(this, arguments)
		this.panel = this.$('.rollup-tree-key-set-panel')
		this.options.maxHeight = () => this.panel.height()

		formHelper.writeToDom(this.model, this.el)

		this.keysSelect = this.$('[name=keys]')
		this.keyChooser = new TagsChooser({
			el: this.keysSelect,
			tags: this.keys,
			selectOptions: {
				// Dataset tags have always allowed duplicates
				// So anything goes!
				creatable: tag => true,
				placeholder: i18n.get('common.add2', 'datasets.trees.key') + '...',
				filterSuggestion: false
			}
		}).render()

		this.onChangeKeys()
	},

	updateValidationBanner: function(code, keys) {
		const banner = this.$('.banner').empty()
		if (keys) {
			let message
			const count = _.size(keys)
			if (count == 1) {
				message = i18n.get(code, keys[0])
			} else {
				const makeListItem = (html, key) => `${html}<li>${_.escape(key)}</li>`
				message = `<span>${i18n.countMessage(code, count)}</span>
				<ul>${_.reduce(keys, makeListItem, '')}</ul>`
			}
			banner.append(message).removeClass('is-not-displayed')
		} else {
			banner.addClass('is-not-displayed')
		}
		this.resize()
	},

	onChangeKeys: function() {
		if (!this.label) return
		this.resize()
		this.$('h3 .size').removeClass('is-not-displayed')
		this.$('h3 .count').text(_.size(this.getKeys()))
	},

	getKeys: function() {
		return selects.val(this.keysSelect)
	},

	readFromDom: function() {
		const id = this.panel.data('id')
		return _.extend(formHelper.readFromDom(this.el), {
			id: _.isNumber(id) ? id : undefined
		})
	},

	_onClickCopy: function() {
		const {id, label, datasetTree, keys} = this.model.attributes
		const url = `api/dataset-trees/${datasetTree.id}/key-sets/${id}/copy`
		this._copy(label, new KeySet(), url, (formData, response) => {
			return new KeySet({
				id: response.id,
				label: formData.label,
				keys,
				datasetTree
			})
		})
	},

	/**
	 * @param {Event} e
	 */
	_onClickDelete: function(e) {
		const {id, datasetTree} = this.model.attributes
		const url = `api/dataset-trees/${datasetTree.id}/key-sets/${id}/delete-dependencies`
		this._delete(e, this.model, url, '', messageKeysByDomainType)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.keyChooser], 'remove')
	}
})

const messageKeysByDomainType = {
	dataset: 'datasets.trees.keysets.delete.confirm'
}

export default RollupTreeKeySetPanel

RollupTreeKeySetPanel.__filename__ = 'admin/datasets/rollup-tree-key-set-panel.js'
